import { HD, FULL_HD, RENDERING_CONTEXT } from '@bedrock-rdk/constants';
import { getFont, FONT } from '@tornado-rdk/typography';
import { PRIMARY, makeThemeColor } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../../tornado/utils/style';
import { SCREEN_HEIGHT } from '../../../tornado/utils/sizes';
import { templates, sizes } from '../../../tornado/poster/poster.constants';

export const defaultContext = makeDefaultStylingContext();

export const POSTER_MARGIN_BOTTOM = {
  [HD]: 16,
  [FULL_HD]: 24,
};

export const colors = {
  label: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const posterSize = sizes[templates.PosterL][RENDERING_CONTEXT.GENERAL][screenSize];

  return {
    w: posterSize.w,
    h: SCREEN_HEIGHT[screenSize],
    Poster: {
      w: posterSize.w,
      h: posterSize.h,
    },
    Label: {
      y: posterSize.h + POSTER_MARGIN_BOTTOM[screenSize],
      text: {
        ...getFont(FONT.KINSHASA_2, screenSize),
        maxLines: 2,
        wordWrapWidth: posterSize.w,
      },
      color: colors.label[colorMode],
    },
  };
};
